import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import * as JSTool from '../store/JSTool';
import TitleView from '../component/TitleView';


export default function Page0(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);

    React.useEffect(() => {

    }, []);

    function videoTap() {
        dispatch(settingActions.showVideoAlert({
            'imgUrl': JSTool.getImgPath('five_00.png'),
            'videoUrl': JSTool.getImgPath('bg/home_video2.mp4'),
        }));
    }

    return (
        <Stack
            id={props.anchorId}
            sx={{
                width: 1,
                height: settingData.innerHeight,
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                bgcolor: 'black',
            }}>

            <Box
                onClick={videoTap}
                component={'video'}
                autoPlay={true}
                loop={true}
                muted={true}
                playsInline={true}
                disablePictureInPicture={true}
                poster={JSTool.getImgPath('five_00.png')}
                src={(JSTool.getImgPath('bg/home_video2.mp4'))}
                sx={{
                    position: 'absolute',
                    cursor: 'pointer',
                    width: 1,
                    height: settingData.innerHeight,
                    objectFit: 'cover',
                }} />

            <Stack sx={{
                position: 'absolute',
                bottom: '30rem',
                alignItems: 'center',
            }}>

                <TitleView title=' Join the fantasy adventure through time and chaos!' mt={'0rem'} fontSize={'20rem'} />

                <Stack sx={{
                    flexDirection: 'row',
                    mb: 2,
                    mt: 3,
                }}>
                    <Box
                        onClick={() => { JSTool.googleTap() }}
                        component={'img'}
                        src={JSTool.getImgPath('release_google.png')}
                        sx={{
                            height: '60rem',
                            filter: 'drop-shadow(0px 0px 15px #2BBFD5)',
                            transitionDuration: '0.3s',
                            cursor: 'pointer',
                            mr: 3,
                            '&:hover': {
                                transform: 'scale(1.05)',
                            }
                        }} />

                    <Box
                        onClick={() => { JSTool.appleTap() }}
                        component={'img'}
                        src={JSTool.getImgPath('release_apple.png')}
                        sx={{
                            height: '60rem',
                            filter: 'drop-shadow(0px 0px 15px #2BBFD5)',
                            transitionDuration: '0.3s',
                            cursor: 'pointer',
                            '&:hover': {
                                transform: 'scale(1.05)',
                            }
                        }} />
                </Stack>
            </Stack>

        </Stack>

    );
}
